export const ATTACHMENT_MAX_BYTES=30_000_000;
export const ATTACHMENT_EXTENSIONS=[".zip",".rar",".jpg",".jpeg",".png",".xlsm",".xlsx",".avi",".mp4",".mp3",".opus",".ogg",".pdf",".webp"] as const;
export const ATTACHMENT_ACCEPT=ATTACHMENT_EXTENSIONS.join(",");
export const IMAGE_ATTACHMENT_ACCEPT=".jpg,.jpeg,.png,.webp";
const allowedExtensions=new Set<string>(ATTACHMENT_EXTENSIONS);
const imageExtensions=new Set([".jpg",".jpeg",".png",".webp"]);

export function fileExtension(fileName:string){const dot=fileName.lastIndexOf(".");return dot>=0?fileName.slice(dot).toLocaleLowerCase("pt-BR"):""}
export function isAllowedAttachmentFile(file:Pick<File,"name">){return allowedExtensions.has(fileExtension(file.name))}
export function isAllowedImageAttachment(file:Pick<File,"name">){return imageExtensions.has(fileExtension(file.name))}
export function attachmentSelectionError(files:Array<Pick<File,"name"|"size">>,existingBytes=0,{imagesOnly=false}:{imagesOnly?:boolean}={}){
  const valid=imagesOnly?isAllowedImageAttachment:isAllowedAttachmentFile;
  const invalid=files.find(file=>!valid(file));
  if(invalid)return `${invalid.name}: formato de arquivo não permitido.`;
  const total=existingBytes+files.reduce((sum,file)=>sum+file.size,0);
  if(total>ATTACHMENT_MAX_BYTES)return"A seção de anexos deve ter no máximo 30 MB.";
  return null;
}
